<template>
  <ProgramCardModal
    :programArticle="selectedProgramArticle"
    :scrollToSection="scrollToSection"
    @close="clearSelectedArticle"
  />

  <div class="lg:hidden flex flex-col justify-center gap-y-8  mt-[40px]">
    <program-card-mobile-card v-for="event in groupedByIsBeforeLunch"
                              :happening="event"
                              :should-have-radio="false"
                              :highlight-color="event.hall === 'purple' ? 'blue' : 'orange'"
                              @clicked="selectProgramArticle"
    >

    </program-card-mobile-card>
    <LunchCard :height="96" time="12:30—14:00"></LunchCard>
    <program-card-mobile-card v-for="event in groupedByIsAfterLunch"
                              :happening="event"
                              :should-have-radio="false"
                              :highlight-color="event.hall === 'purple' ? 'blue' : 'orange'"
                              @clicked="selectProgramArticle"
    >
    </program-card-mobile-card>

    <div class="
           flex
           items-center
           justify-between
           h-24
           col-span-2
           px-6
           bg-white
           rounded-[20px]
           shadow-md
      ">
      <div class="flex flex-col">
        <p class="font-semibold text-brand-orange text-tiny">18:00 - 22:00</p>
        <p class="font-semibold text-body">Afterparty</p>
      </div>
      <div class="flex">
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Icon">
            <path id="Vector"
                  d="M23.5459 2.79786C23.2986 2.78889 23.0529 2.84124 22.8307 2.95025C22.6085 3.05926 22.4167 3.22155 22.2725 3.42264C22.1282 3.62374 22.036 3.8574 22.004 4.1028C21.9719 4.3482 22.0011 4.59772 22.0889 4.82911C23.0265 7.40762 23.2046 9.29211 22.7373 11.0576C22.3416 12.5524 21.3938 14.0729 19.8193 15.8057L18.8564 14.8428C17.9707 13.9571 16.74 13.6898 15.626 13.9385C14.5119 14.1871 13.5144 14.9536 13.0889 16.1318L3.08886 43.8076C2.99231 44.0755 2.974 44.3654 3.03607 44.6433C3.09815 44.9212 3.23803 45.1757 3.43938 45.377C3.64074 45.5784 3.89524 45.7183 4.17315 45.7803C4.45106 45.8424 4.74089 45.8241 5.00878 45.7276L32.6865 35.7276V35.7295C35.0439 34.8799 35.7441 31.7341 33.9736 29.9619C33.9736 29.9613 33.9736 29.9606 33.9736 29.96L33.001 28.9873C34.7375 27.4077 36.2614 26.4579 37.7588 26.0615C39.5243 25.5942 41.4088 25.7723 43.9873 26.71C44.1727 26.7783 44.3698 26.8093 44.5673 26.8012C44.7647 26.7931 44.9587 26.7461 45.1379 26.6629C45.3171 26.5796 45.4781 26.4618 45.6117 26.3161C45.7452 26.1704 45.8487 25.9998 45.9161 25.814C45.9835 25.6283 46.0135 25.431 46.0045 25.2336C45.9954 25.0362 45.9475 24.8425 45.8633 24.6637C45.7792 24.4849 45.6606 24.3244 45.5143 24.1916C45.368 24.0588 45.1968 23.9562 45.0107 23.8897C43.55 23.3585 42.1665 23.0113 40.8369 22.8799C39.5073 22.7485 38.2315 22.8323 36.9893 23.1611C34.8335 23.7318 32.8779 24.9933 30.8642 26.8506L26.581 22.5674C27.0193 22.3971 27.4676 22.3668 28.1201 22.3135C29.275 22.2191 31.0685 21.9895 32.6182 20.4404C34.1686 18.89 34.3965 17.0978 34.4912 15.9424C34.586 14.787 34.5466 14.2694 35.4971 13.3193C36.4476 12.3692 36.9666 12.4084 38.1221 12.3135C39.2776 12.2186 41.0703 11.9889 42.6201 10.4385C42.8367 10.2276 42.9844 9.95626 43.0441 9.65996C43.1038 9.36366 43.0726 9.05625 42.9546 8.77799C42.8366 8.49973 42.6372 8.26361 42.3827 8.10057C42.1282 7.93753 41.8304 7.85516 41.5283 7.86427C41.1394 7.87612 40.7704 8.03859 40.499 8.31739C39.5489 9.26794 39.0312 9.22839 37.876 9.32325C36.7207 9.41812 34.9264 9.64842 33.376 11.1983C31.8254 12.7482 31.5977 14.5409 31.5029 15.6963C31.4082 16.8517 31.4476 17.3688 30.4971 18.3193C29.5478 19.2683 29.0311 19.2289 27.876 19.3233C26.9677 19.3975 25.6642 19.5645 24.3955 20.3818L21.956 17.9424C23.8082 15.932 25.066 13.9796 25.6357 11.8272C26.2934 9.34267 25.9715 6.72717 24.9092 3.80567C24.8101 3.5198 24.6268 3.27058 24.3835 3.09072C24.1402 2.91086 23.8483 2.80878 23.5459 2.79786ZM30.999 4.81739C30.6763 4.81739 30.3529 4.94003 30.1064 5.18653L29.3682 5.92482C28.8752 6.41782 28.8752 7.21697 29.3682 7.70997L30.1064 8.44825C30.5994 8.94025 31.3986 8.94025 31.8916 8.44825L32.6299 7.70997C33.1229 7.21697 33.1229 6.41782 32.6299 5.92482L31.8916 5.18653C31.6451 4.94003 31.3218 4.81739 30.999 4.81739ZM14.999 7.81739C14.6763 7.81739 14.3529 7.94003 14.1064 8.18653L13.3682 8.92482C12.8752 9.41782 12.8752 10.217 13.3682 10.71L14.1064 11.4483C14.5994 11.9403 15.3986 11.9403 15.8916 11.4483L16.6299 10.71C17.1229 10.217 17.1229 9.41782 16.6299 8.92482L15.8916 8.18653C15.6451 7.94003 15.3218 7.81739 14.999 7.81739ZM8.99901 12.3174C8.67626 12.3174 8.35294 12.44 8.10644 12.6865L7.36816 13.4248C6.87515 13.9178 6.87515 14.717 7.36816 15.21L8.10644 15.9483C8.59944 16.4403 9.39859 16.4403 9.89159 15.9483L10.6299 15.21C11.1229 14.717 11.1229 13.9178 10.6299 13.4248L9.89159 12.6865C9.64509 12.44 9.32176 12.3174 8.99901 12.3174ZM16.2646 16.794C16.4151 16.7604 16.5831 16.8155 16.7334 16.9658C16.734 16.9658 16.7347 16.9658 16.7353 16.9658L31.8525 32.083C32.1521 32.3845 32.0689 32.7611 31.6689 32.9053C31.6683 32.9059 31.6676 32.9066 31.667 32.9072L6.99511 41.8213L15.9092 17.1494C15.9817 16.9487 16.1142 16.8275 16.2646 16.794ZM39.999 16.8174C39.6763 16.8174 39.3529 16.94 39.1064 17.1865L38.3682 17.9248C37.8752 18.4178 37.8752 19.217 38.3682 19.71L39.1064 20.4483C39.5994 20.9403 40.3986 20.9403 40.8916 20.4483L41.6299 19.71C42.1229 19.217 42.1229 18.4178 41.6299 17.9248L40.8916 17.1865C40.6451 16.94 40.3218 16.8174 39.999 16.8174ZM39.999 29.8174C39.6763 29.8174 39.3529 29.94 39.1064 30.1865L38.3682 30.9248C37.8752 31.4178 37.8752 32.217 38.3682 32.71L39.1064 33.4483C39.5994 33.9403 40.3986 33.9403 40.8916 33.4483L41.6299 32.71C42.1229 32.217 42.1229 31.4178 41.6299 30.9248L40.8916 30.1865C40.6451 29.94 40.3218 29.8174 39.999 29.8174ZM36.999 36.8174C36.6763 36.8174 36.3529 36.94 36.1064 37.1865L35.3682 37.9248C34.8752 38.4178 34.8752 39.217 35.3682 39.71L36.1064 40.4483C36.5994 40.9403 37.3986 40.9403 37.8916 40.4483L38.6299 39.71C39.1229 39.217 39.1229 38.4178 38.6299 37.9248L37.8916 37.1865C37.6451 36.94 37.3218 36.8174 36.999 36.8174Z"
                  fill="#2699C6"/>
          </g>
        </svg>

      </div>
    </div>
  </div>


  <div class="hidden lg:grid justify-center gap-x-4 w-full grid-cols-2 mt-[72px] relative">
    <div class="absolute w-[25%] h-full bg-[#2699C6] opacity-70 z-[-1] right-0" style="filter: blur(400px); border-radius: 1943px;"></div>
    <div class="absolute w-[25%] h-full bg-[#F4A02D] opacity-70 z-[-1] left-0" style="filter: blur(400px); border-radius: 1943px;"></div>
    <div class="mb-5">
      <h2 class="text-left font-semibold text-brand-orange text-[24px]">Leadhub sál</h2>
    </div>

    <div class="mb-5">
      <h2 class="text-right font-semibold text-[#2699C6] text-[24px]">
        Notino sál
      </h2>
    </div>
    <div>
      <ProgramCard
        v-for="(happening, i) in firstHallMorning"
        :key="i"
        :programArticle="happening"
        :textTruncateChars="105"
        @clicked="selectProgramArticle"
        :timeslotSelections="timeslotSelectionsMutable"
        :userLoggedIn="userLoggedIn"
        :program-voting-opened="votingOpened"
        @update:timeslotSelections="updateTimeSlot"
        class="mb-[20px]"
      />
    </div>

    <div>
      <ProgramCard
        v-for="(happening, i) in secondHallMorning"
        :key="i"
        :textTruncateChars="105"
        :programArticle="happening"
        @clicked="selectProgramArticle"
        :timeslotSelections="timeslotSelectionsMutable"
        :userLoggedIn="userLoggedIn"
        :program-voting-opened="votingOpened"
        @update:timeslotSelections="updateTimeSlot"
        :highlight-color="'blue'"
        class="mb-[20px]"
      />

    </div>

    <LunchCard class="my-[10px] mb-[30px]" :height="96" time="12:30—14:00"></LunchCard>

    <div>
      <template v-for="(happening, i) in firstHallAfterLunch"
                :key="i">
        <ProgramCard
          :programArticle="happening"
          @clicked="selectProgramArticle"
          :textTruncateChars="105"
          :timeslotSelections="timeslotSelectionsMutable"
          :userLoggedIn="userLoggedIn"
          :program-voting-opened="votingOpened"
          @update:timeslotSelections="updateTimeSlot"
          class="mb-[20px]"
        />
      </template>
    </div>

    <div>
      <template v-for="(happening, i) in secondHallAfterLunch"
                :key="i">
        <ProgramCard
          class="mb-[20px]"
          :programArticle="happening"
          @clicked="selectProgramArticle"
          :textTruncateChars="105"
          :timeslotSelections="timeslotSelectionsMutable"
          :userLoggedIn="userLoggedIn"
          :program-voting-opened="votingOpened"
          @update:timeslotSelections="updateTimeSlot"
          :highlight-color="'blue'"
        />
      </template>
    </div>
    <div class="
           flex
           items-center
           justify-between
           h-24
           col-span-2
           px-6
           bg-white
           rounded-[20px]
           shadow-md
      ">
      <div class="flex flex-col">
        <p class="font-semibold text-brand-orange text-tiny">18:00 - 22:00</p>
        <p class="font-semibold text-body">Afterparty</p>
      </div>
      <div class="flex">
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Icon">
            <path id="Vector"
                  d="M23.5459 2.79786C23.2986 2.78889 23.0529 2.84124 22.8307 2.95025C22.6085 3.05926 22.4167 3.22155 22.2725 3.42264C22.1282 3.62374 22.036 3.8574 22.004 4.1028C21.9719 4.3482 22.0011 4.59772 22.0889 4.82911C23.0265 7.40762 23.2046 9.29211 22.7373 11.0576C22.3416 12.5524 21.3938 14.0729 19.8193 15.8057L18.8564 14.8428C17.9707 13.9571 16.74 13.6898 15.626 13.9385C14.5119 14.1871 13.5144 14.9536 13.0889 16.1318L3.08886 43.8076C2.99231 44.0755 2.974 44.3654 3.03607 44.6433C3.09815 44.9212 3.23803 45.1757 3.43938 45.377C3.64074 45.5784 3.89524 45.7183 4.17315 45.7803C4.45106 45.8424 4.74089 45.8241 5.00878 45.7276L32.6865 35.7276V35.7295C35.0439 34.8799 35.7441 31.7341 33.9736 29.9619C33.9736 29.9613 33.9736 29.9606 33.9736 29.96L33.001 28.9873C34.7375 27.4077 36.2614 26.4579 37.7588 26.0615C39.5243 25.5942 41.4088 25.7723 43.9873 26.71C44.1727 26.7783 44.3698 26.8093 44.5673 26.8012C44.7647 26.7931 44.9587 26.7461 45.1379 26.6629C45.3171 26.5796 45.4781 26.4618 45.6117 26.3161C45.7452 26.1704 45.8487 25.9998 45.9161 25.814C45.9835 25.6283 46.0135 25.431 46.0045 25.2336C45.9954 25.0362 45.9475 24.8425 45.8633 24.6637C45.7792 24.4849 45.6606 24.3244 45.5143 24.1916C45.368 24.0588 45.1968 23.9562 45.0107 23.8897C43.55 23.3585 42.1665 23.0113 40.8369 22.8799C39.5073 22.7485 38.2315 22.8323 36.9893 23.1611C34.8335 23.7318 32.8779 24.9933 30.8642 26.8506L26.581 22.5674C27.0193 22.3971 27.4676 22.3668 28.1201 22.3135C29.275 22.2191 31.0685 21.9895 32.6182 20.4404C34.1686 18.89 34.3965 17.0978 34.4912 15.9424C34.586 14.787 34.5466 14.2694 35.4971 13.3193C36.4476 12.3692 36.9666 12.4084 38.1221 12.3135C39.2776 12.2186 41.0703 11.9889 42.6201 10.4385C42.8367 10.2276 42.9844 9.95626 43.0441 9.65996C43.1038 9.36366 43.0726 9.05625 42.9546 8.77799C42.8366 8.49973 42.6372 8.26361 42.3827 8.10057C42.1282 7.93753 41.8304 7.85516 41.5283 7.86427C41.1394 7.87612 40.7704 8.03859 40.499 8.31739C39.5489 9.26794 39.0312 9.22839 37.876 9.32325C36.7207 9.41812 34.9264 9.64842 33.376 11.1983C31.8254 12.7482 31.5977 14.5409 31.5029 15.6963C31.4082 16.8517 31.4476 17.3688 30.4971 18.3193C29.5478 19.2683 29.0311 19.2289 27.876 19.3233C26.9677 19.3975 25.6642 19.5645 24.3955 20.3818L21.956 17.9424C23.8082 15.932 25.066 13.9796 25.6357 11.8272C26.2934 9.34267 25.9715 6.72717 24.9092 3.80567C24.8101 3.5198 24.6268 3.27058 24.3835 3.09072C24.1402 2.91086 23.8483 2.80878 23.5459 2.79786ZM30.999 4.81739C30.6763 4.81739 30.3529 4.94003 30.1064 5.18653L29.3682 5.92482C28.8752 6.41782 28.8752 7.21697 29.3682 7.70997L30.1064 8.44825C30.5994 8.94025 31.3986 8.94025 31.8916 8.44825L32.6299 7.70997C33.1229 7.21697 33.1229 6.41782 32.6299 5.92482L31.8916 5.18653C31.6451 4.94003 31.3218 4.81739 30.999 4.81739ZM14.999 7.81739C14.6763 7.81739 14.3529 7.94003 14.1064 8.18653L13.3682 8.92482C12.8752 9.41782 12.8752 10.217 13.3682 10.71L14.1064 11.4483C14.5994 11.9403 15.3986 11.9403 15.8916 11.4483L16.6299 10.71C17.1229 10.217 17.1229 9.41782 16.6299 8.92482L15.8916 8.18653C15.6451 7.94003 15.3218 7.81739 14.999 7.81739ZM8.99901 12.3174C8.67626 12.3174 8.35294 12.44 8.10644 12.6865L7.36816 13.4248C6.87515 13.9178 6.87515 14.717 7.36816 15.21L8.10644 15.9483C8.59944 16.4403 9.39859 16.4403 9.89159 15.9483L10.6299 15.21C11.1229 14.717 11.1229 13.9178 10.6299 13.4248L9.89159 12.6865C9.64509 12.44 9.32176 12.3174 8.99901 12.3174ZM16.2646 16.794C16.4151 16.7604 16.5831 16.8155 16.7334 16.9658C16.734 16.9658 16.7347 16.9658 16.7353 16.9658L31.8525 32.083C32.1521 32.3845 32.0689 32.7611 31.6689 32.9053C31.6683 32.9059 31.6676 32.9066 31.667 32.9072L6.99511 41.8213L15.9092 17.1494C15.9817 16.9487 16.1142 16.8275 16.2646 16.794ZM39.999 16.8174C39.6763 16.8174 39.3529 16.94 39.1064 17.1865L38.3682 17.9248C37.8752 18.4178 37.8752 19.217 38.3682 19.71L39.1064 20.4483C39.5994 20.9403 40.3986 20.9403 40.8916 20.4483L41.6299 19.71C42.1229 19.217 42.1229 18.4178 41.6299 17.9248L40.8916 17.1865C40.6451 16.94 40.3218 16.8174 39.999 16.8174ZM39.999 29.8174C39.6763 29.8174 39.3529 29.94 39.1064 30.1865L38.3682 30.9248C37.8752 31.4178 37.8752 32.217 38.3682 32.71L39.1064 33.4483C39.5994 33.9403 40.3986 33.9403 40.8916 33.4483L41.6299 32.71C42.1229 32.217 42.1229 31.4178 41.6299 30.9248L40.8916 30.1865C40.6451 29.94 40.3218 29.8174 39.999 29.8174ZM36.999 36.8174C36.6763 36.8174 36.3529 36.94 36.1064 37.1865L35.3682 37.9248C34.8752 38.4178 34.8752 39.217 35.3682 39.71L36.1064 40.4483C36.5994 40.9403 37.3986 40.9403 37.8916 40.4483L38.6299 39.71C39.1229 39.217 39.1229 38.4178 38.6299 37.9248L37.8916 37.1865C37.6451 36.94 37.3218 36.8174 36.999 36.8174Z"
                  fill="#2699C6"/>
          </g>
        </svg>

      </div>
    </div>
  </div>
</template>

<script>
import ProgramCardModal from "./ProgramCardModal.vue";
import ProgramCard from "./ProgramCard.vue";
import ProgramCardMobile from "./ProgramCardMobile.vue";
import {isAfter, isBefore, parse} from "date-fns";
import LunchCard from "./LunchCard.vue";
import ProgramCardMobileCard from "./ProgramCardMobileCard.vue";

export default {
  components: {
    ProgramCardMobileCard,
    ProgramCardModal,
    ProgramCard,
    ProgramCardMobile,
    LunchCard
  },

  props: {
    programEvents: {
      type: Array,
      default: () => [],
    },

    timeslotSelections: {
      type: Object,
      default: undefined,
    },

    userLoggedIn: {
      type: Boolean,
      default: true,
    },

    votingOpened: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectedProgramArticle: null,
      hall1: "heureka",
      hall2: "purple",
      timeslotSelectionsMutable: this.timeslotSelections,
      scrollToSection: false
    };
  },

  computed: {
    canVote() {
      return this.userLoggedIn && this.votingOpened;
    },
    groupedByIsBeforeLunch() {
      return this.programEvents.filter((event) => !this.isAfterLunch(event))
    },
    groupedByIsAfterLunch() {
      return this.programEvents.filter((event) => this.isAfterLunch(event))
    },

    groupedByTimeSlots() {
      console.log(this.programEvents, 'eventy')
      const happenings = this.programEvents.filter(
        (event) => event.type !== "workshop" && event.timeslot !== null
      );

      const grouped = happenings.reduce((groupedHappenings, happening) => {
        if (groupedHappenings[happening.timeslot.index] == null) {
          groupedHappenings[happening.timeslot.index] = [];
        }

        if (
          groupedHappenings[happening.timeslot.index][happening.hall] == null
        ) {
          groupedHappenings[happening.timeslot.index][happening.hall] = [];
        }

        groupedHappenings[happening.timeslot.index][happening.hall].push(
          happening
        );

        return groupedHappenings;
      }, {});

      return grouped;
    },

    firstHall() {
      return this.programEvents
        .filter((e) => e.hall === this.hall1)
        .sort((firstEvent, secondEvent) => {
          const isBef = isBefore(
            parse(firstEvent.start, "HH:mm", new Date()),
            parse(secondEvent.start, "HH:mm", new Date())
          );

          //Safari coertion fix
          return isBef ? -1 : 1;
        });
    },

    secondHall() {
      return this.programEvents
        .filter((e) => e.hall === this.hall2)
        .sort((firstEvent, secondEvent) => {
          const isBef = isBefore(
            parse(firstEvent.start, "HH:mm", new Date()),
            parse(secondEvent.start, "HH:mm", new Date())
          );

          //Safari coertion fix
          return isBef ? -1 : 1;
        });
    },

    firstHallMorning() {
      return this.firstHall.filter(event => !this.isAfterLunch(event))
    },

    secondHallMorning() {
      return this.secondHall.filter(event => !this.isAfterLunch(event))
    },

    firstHallAfterLunch() {
      return this.firstHall.filter(event => this.isAfterLunch(event))
      //return this.getEventsWithPlaceholders()[0];
    },

    secondHallAfterLunch() {
      return this.secondHall.filter(event => this.isAfterLunch(event))
      //return this.getEventsWithPlaceholders()[1];
    },
  },

  methods: {
    getEventsWithPlaceholders() {
      console.log('asd', this.groupedByTimeSlots)
      const byTimeslotAfternoon = this.groupedByTimeSlots;

      const halls = [[], []];

      for (const timeslot in Object.keys(byTimeslotAfternoon)) {
        if (Number(timeslot) < 3) continue; // only consider afternoon events
        const group = byTimeslotAfternoon[timeslot];
        console.log(group)
        const firstHall = group?.heureka ?? [];
        const secondHall = group?.purple ?? [];

        const maxSize = Math.max(firstHall.length, secondHall.length);
        for (const event of firstHall) {
          halls[0].push({"event": event, "placeholder": false});
        }
        for (const event of secondHall) {
          halls[1].push({"event": event, "placeholder": false});
        }
        for (let i = firstHall.length; i < maxSize; i++) {
          halls[0].push({"placeholder": true});
        }
        for (let i = secondHall.length; i < maxSize; i++) {
          halls[1].push({"placeholder": true});
        }
      }

      return halls;
    },
    parseDate(time) {
      return parse(time, "HH:mm", new Date());
    },
    isAfterLunch(event) {
      const date = this.parseDate(event.start);
      const lunch = this.parseDate("13:30");
      return isAfter(date, lunch);
    },
    selectProgramArticleAndAddToURL(article) {
      this.selectedProgramArticle = article;

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('programId', article.id)

      const newRelativePathQuery = window.location.pathname + '?' + urlParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    },
    selectProgramArticle(article) {
      this.scrollToSection = false;
      this.selectProgramArticleAndAddToURL(article);
    },
    clearSelectedArticle() {
      this.selectedProgramArticle = undefined;
      history.pushState(null, '', window.location.pathname);
    },
    updateTimeSlot(newTimeSlots) {
      this.timeslotSelectionsMutable = {...newTimeSlots};
    },

    selectArticleIfPresentInSearchParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const programId = urlParams.get('programId');

      if (programId !== undefined) {
        this.programEvents.forEach((event) => {
          if (event.id === Number(programId)) {
            this.scrollToSection = true;
            this.selectProgramArticleAndAddToURL(event);
          }
        });
      }
    }
  },

  mounted() {
    this.selectArticleIfPresentInSearchParams();
  }
};
</script>

<style>
</style>
